import React, { useEffect, useRef } from 'react';

// Dribbble / Behance presentation pieces for a project page.
// <ShowcaseReel slug="pawtimo" video />        → the motion cover (plays only while on screen)
// <ShowcaseReel slug="pawtimo" frames={[1,2]} /> → those presentation frames, full width
export default function ShowcaseReel({ slug, video, card, frames = [], alt = '' }) {
  const ref = useRef(null);
  useEffect(() => {
    const v = ref.current;
    if (!v || !('IntersectionObserver' in window)) return;
    const io = new IntersectionObserver(([e]) => { if (e.isIntersecting) v.play().catch(() => {}); else v.pause(); }, { threshold: 0.25 });
    io.observe(v);
    return () => io.disconnect();
  }, []);
  const base = `/showcase/${slug}/`;
  const box = { width: '100%', display: 'block', borderRadius: 16, aspectRatio: '4 / 3', objectFit: 'cover', background: '#0f1115' };
  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: 'clamp(12px, 2vw, 20px)' }}>
      {card && (
        <a href={card} target="_blank" rel="noopener noreferrer" aria-label={`Visit ${alt}`} style={{ display: 'block', borderRadius: 24, overflow: 'hidden', boxShadow: '0 24px 60px rgba(0,0,0,0.28)' }}>
          <img src={`${base}end.webp`} alt={alt} style={{ width: '100%', display: 'block', aspectRatio: '8 / 3', objectFit: 'cover' }} />
        </a>
      )}
      {video && <video ref={ref} src={`${base}cover.mp4`} poster={`${base}poster.jpg`} muted loop playsInline preload="none" style={box} aria-label={`${alt} motion`} />}
      {frames.map(n => (
        <img key={n} src={`${base}${String(n).padStart(2, '0')}.webp`} alt={`${alt} ${n}`} loading="lazy" decoding="async" style={box} />
      ))}
    </div>
  );
}
